class StickyNav {
  constructor() {
    this.navLinks = document.querySelectorAll(".sticky-nav a");
    this.init();
  }

  init() {
    this.navLinks.forEach(link => {
      link.addEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Remove active class from all anchors
    this.navLinks.forEach(link => link.classList.remove("active"));

    // Add active class to the clicked anchor
    event.currentTarget.classList.add("active");

    const targetId = event.currentTarget.getAttribute("href").substring(1); // Remove '#'
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 50, // Adjust for fixed header if needed
        behavior: "smooth"
      });

      // Update the URL without reloading the page
      history.pushState(null, "", `#${targetId}`);
    }
  }
}

// Initialize the StickyNav class when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => new StickyNav());
